// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2iSHe","selects":"Documents_selects__2Jb5L"};